const { optimaConfigConstants } = require('../../optima');
const { NIMBUS_DATA_TYPES } = require('../nimbus-data-types');

module.exports = {
  displayName: 'Auto Run',
  description: 'Setup Auto Run',
  sortOrder: 2,
  name: 'autoRun',
  documentKey: 'auto_run',
  values: {
    frequency: {
      dataType: NIMBUS_DATA_TYPES.STRING,
      allowedValues: Object.values(optimaConfigConstants.FrequencyType),
      defaultValue: optimaConfigConstants.FrequencyType.ACTUAL,
      displayName: 'Frequency',
      documentKey: 'frequency',
    },
    interval: {
      dataType: NIMBUS_DATA_TYPES.STRING,
      defaultValue: '',
      displayName: 'Interval',
      documentKey: 'interval',
    },
    optimaRunDelay: {
      dataType: NIMBUS_DATA_TYPES.STRING,
      defaultValue: '',
      displayName: 'Optima run delay',
      documentKey: 'optima_run_delay',
    },
    triggerPullPicklist: {
      dataType: NIMBUS_DATA_TYPES.BOOLEAN,
      defaultValue: '',
      displayName: 'Trigger pull picklist',
      documentKey: 'trigger_pull_picklist',
    },
  },
};
